import KunLoading93 from './src/index'

KunLoading93.install = function (Vue) {
	Vue.component(KunLoading93.name, KunLoading93);
}

export default KunLoading93;
